/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {changeOwner} from '../api'

export const useMutationChangeOwner = createReactQueryMutationHook('changeOwner', changeOwner)
